// ----
// split-screen and split-screen tab functionality
// ----

var SCM = SCM || {};

SCM.SplitScreen = (function ($) {

    // ARIA Tabs wiring for the split-view tab strip (ACS-1348). The ids are
    // generated in script rather than declared in the views because GSW and OUP
    // ship their own DynamicWidgetTabbedNavigation.cshtml overrides and would
    // otherwise miss the wiring.
    var TAB_ID_PREFIX = 'split-view-tab-';
    var PANEL_ID_PREFIX = 'split-view-panel-';
    var FULL_TEXT_TAB_ID = 'split-view-tab-full-text';
    var FULL_TEXT_PANEL_ID = 'split-view-panel-full-text';

    return {
        getDocWidth: getDocWidth,
        ScrollToWindowHash: ScrollToWindowHash,
        JumpToPeerReviewTab: JumpToPeerReviewTab,
        jumpToReferenceInRightPane: jumpToReferenceInRightPane,
        removeTabsWithNoContent: removeTabsWithNoContent,
        isSplitScreen: isSplitScreen,
        init: init
    };

	function getDocWidth() {
		if (self.innerWidth) {
			return self.innerWidth;
		}

		if (document.documentElement && document.documentElement.clientWidth) {
			return document.documentElement.clientWidth;
		}

		if (document.body) {
			return document.body.clientWidth;
		}
	}

    function rightPanelHeight() {
        if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
            setTimeout(
                function () {
                    if ($('.panels').length) {

                        var height = $(window).height();
                        var panelTop = $('.panels').offset().top;
                        var panelHeight = height - panelTop;

                        $('.panels').css('height', panelHeight);
                        $('.dynamic-widget-inner-wrap').addClass('panel-scroll');
                    }
                },
                5000);
        }
    }

    function hasTabContent($panelInnerWrap) {
        var hasContent = true;
        var innerWrap = $panelInnerWrap.find('.widget-dynamic-inner-wrap,.widget-dynamic-panel-content-holder');
        if (innerWrap && innerWrap.length) {
         hasContent = false;
         innerWrap.each(function(i, elem) {
          var innerWrapContent = $(elem).html();
          if (innerWrapContent && innerWrapContent.length && !/^\s*$/.test(innerWrapContent)) {
           hasContent = true;
           return false;
          }
         });
        }
        return hasContent;
    }

    function ScrollToWindowHash() {
        var hash = window.location.hash;

        if ($('.pg_ArticleSplitView, .pg_articlesplitview').length) {
            var scrollToLink = $('.tab-split-view-figures-and-tables-pane').find('span' + hash + '');
            var scrollable = scrollToLink.parents('.dynamic-widget-inner-wrap');
            if ($(scrollable).length) {
                scrollable.delay(100).animate({
                        scrollTop: scrollToLink.position().top - 10
                    },
                    250);
            }
        }
    }

    function JumpToPeerReviewTab() {
        var peerReviewId = SCM.JSUtility.getSearchParamByName('peerReviewId');
        if (peerReviewId && $('.pg_ArticleSplitView, .pg_articlesplitview').length) {
            var $targetTab = $('.tab-split-view-peer-review-pane');
            var $scrollToLink = $(document.getElementById(peerReviewId));
            var scrollable = $scrollToLink.parents('.dynamic-widget-inner-wrap');
            if ($(scrollable).length && $scrollToLink.length) {
                $targetTab.click();
                scrollable.delay(100).animate({
                        scrollTop: $scrollToLink.position().top - 10
                    },
                    250);
            }
        }

    }

    function jumpToTarget(panelTriggerId) {
        var target = $('.panels').find('div[data-id="' + panelTriggerId + '"],div[content-id~="' + panelTriggerId + '"i]');
        var targetPanel = $(target).closest('.dynamic-widget-inner-wrap').attr('data-display-order');
        var targetTab = $(target).closest('.aside').find('.tabs').find('.tab[data-tab="' + targetPanel + '"]');

        if (targetPanel) {
            $(targetTab).click();
            if ($(target).length) {
                var targetScroll = $('.dynamic-widget-inner-wrap[data-display-order="' + targetPanel + '"]');
                targetScroll.animate({
                    scrollTop: targetScroll.scrollTop() + target.position().top - 10
                }, 250);
            }
            return false;
        }
    }

    function jumpToTargetBySectionId(target) {
        var targetPanel = $(target).closest('.dynamic-widget-inner-wrap').attr('data-display-order');
        var targetTab = $(target).closest('.aside').find('.tabs').find('.tab[data-tab="' + targetPanel + '"]');

        if (targetPanel) { //split view panel on right pane
            $(targetTab).click();
            if ($(target).length) {
                var targetScroll = $('.dynamic-widget-inner-wrap[data-display-order="' + targetPanel + '"]');
                targetScroll.scrollTop(targetScroll.scrollTop() + target.position().top - 10);
            }
            return false;
        } else { //item is in left pane
            targetScroll = $('.article.js-content-splitview');
            targetScroll.click();
            targetScroll.scrollTop(target.position().top);
            return false;
        }
    }

    function jumpToSubSection() {
        // Check if #sectionID in url, find element on page, see if it has related data-id to jump to
        var hash = Theme.HashHandler.getHashReference('sectionID-');

        try {
            var $section = $(hash);
            if ($section.length) {
                jumpToTargetBySectionId($section);
            }
        } catch (error) {
            console.error(error);
        }
    }

    function removeTabsWithNoContent() {
        var tabPanels = $('body.pg_articlesplitview .panels > .dynamic-widget-inner-wrap');
        var hasFigShare = $('#articlefulltext_figshare').length > 0;

        tabPanels.each(function () {
            var panelInnerWrap = $(this).find('.widget-dynamic-inner-wrap,.widget-dynamic-panel-content-holder');
            var panelContent = panelInnerWrap.html();
            var dataDisplayOrder = $(this).attr('data-display-order');

            if (dataDisplayOrder !== undefined) {
                var $tabLink = $(`body.pg_articlesplitview .tab[data-tab="${dataDisplayOrder}"]`);
                var isSupplement = $tabLink.is('[class*="supplement"]');

                if (!panelContent || panelContent.length === 0 || /^\s*$/.test(panelContent)) {
                    if (!(hasFigShare && isSupplement)) {
                        $(this).remove();
                        $tabLink.remove();
                    }
                }
                else {
                    var hasContent = hasTabContent(panelInnerWrap);
                    if (!hasContent && !(hasFigShare && isSupplement)) {
                        $(this).remove();
                        $tabLink.remove();
                    }
                }

                if (!hasContent && hasFigShare && isSupplement) {
                    $(this).hide();
                    // there could have been another js adding content to it now.
                    if (!$tabLink.hasClass('js-hascontent')) {
                        $tabLink.hide();
                    }
                }
            }
        });
    }

    // Check for split view, of any type (article, book, etc...)
    function isSplitScreen() {
        return $('.js-splitview-aside').length;
    }

    function jumpToReferenceInRightPane(refId) {
        var $target = $('.aside .ref-list').find('div[data-id="' + refId + '"],div[content-id~="' + refId + '"]');

        if (!$target.length) {
            var multipleRefIds = refId.split(' ');
            if (multipleRefIds.length) {
                refId = multipleRefIds[0];
            }
            $target = $('.aside .ref-list').find('div[data-id="' + refId + '"],div[content-id~="' + refId + '"]');
        }

        // Using ReferencesCss isn't the best, but it's faster than a complex DOM traversal
        // Ideally, we'll get more accurate dynamic-widget naming and can use that
        var $refPanel = $('.ReferencesCss, .split-view-references-pane').parents('.dynamic-widget-inner-wrap');
        var $targetTab = $('.tab-ReferencesCss, .tab-split-view-references-pane');
        var targetPanel = $refPanel.attr('data-display-order');

        if (!$targetTab.hasClass('active')) {
            // If the tab is NOT active, have to switch over to it
            $targetTab.click();
        }

        var $targetScroll = $('.dynamic-widget-inner-wrap[data-display-order="' + targetPanel + '"]');
        if ($target.length) {
            $targetScroll.addClass('scroll');
            $targetScroll.delay(100).animate({
                scrollTop: $targetScroll.scrollTop() + $target.position().top - 10
            }, 250, function () {
                SCM.JumpLinks.moveFocusWithinTarget($target);
            });
        }
    }

    // Every tab currently on show, in DOM (visual) order. Read at call time
    // rather than cached at init because removeTabsWithNoContent deletes tabs
    // after load and the Full Text tab is only visible in the mobile layout.
    function getVisibleTabs() {
        return $('body.pg_articlesplitview .tabs .tab:visible');
    }

    // The ARIA Tabs pattern uses a roving tabindex: exactly one tab sits in the
    // page tab order and the arrow keys move between the rest. That is what makes
    // the strip a single, predictable focus stop rather than one stop per tab.
    function setRovingTabStop($tab) {
        getVisibleTabs().attr('tabindex', '-1');
        $tab.attr('tabindex', '0');
    }

    // The Full Text tab shows the article pane instead of one of the widget
    // panels, so its tab/panel pairing is wired separately. The tabpanel role is
    // applied only while the mobile layout is in play, because on desktop the
    // article pane is permanently visible page content rather than a panel the
    // strip swaps in and out - labelling it as one there would misdescribe the
    // layout to assistive technology (ACS-1348).
    function syncFullTextTabPanel($contentPanel, isMobile) {
        var $fullTextTab = $('.tab-FullTextCss');
        // narrowed to one element so the generated id stays unique even if a
        // client's article markup nests another .article inside the pane
        var $articlePane = $contentPanel.first();

        if (!$fullTextTab.length || !$articlePane.length) {
            return;
        }

        $articlePane.attr('id', FULL_TEXT_PANEL_ID);
        $fullTextTab.attr('aria-controls', FULL_TEXT_PANEL_ID);

        if (isMobile) {
            $articlePane.attr({
                'role': 'tabpanel',
                'aria-labelledby': FULL_TEXT_TAB_ID
            });
        } else {
            $articlePane.removeAttr('role').removeAttr('aria-labelledby');
        }
    }

    // Below the mobile breakpoint the tabs render as bare icons and both of their
    // text sources are display:none - the icon's own text always is, and the
    // visible label is hidden by the responsive rules - which leaves every tab
    // with no accessible name at all, so a screen reader announces "tab, 1 of 6"
    // and never says which tab it is (WCAG 4.1.2, Level A). Promote the label to
    // an aria-label so the name survives whatever CSS does to the text. The string
    // is identical to the desktop visible label, so the desktop announcement is
    // unchanged and Label in Name still holds (ACS-1348).
    function labelTabsForAssistiveTechnology() {
        $('body.pg_articlesplitview .tabs .tab').each(function () {
            var $tab = $(this);
            // .tab__text carries the human-readable title; .tab__icon-text carries
            // a lowercased, space-stripped variant meant for the icon font, which
            // would announce as "figures&tables".
            var label = $tab.find('.tab__text').text().trim();

            if (label) {
                $tab.attr('aria-label', label);
            }
        });
    }

    function generateHtml($tabLinks, $tabPanels) {
        // generate the fullText tab for mobile
        // could be hardcoded, but is easier to deal
        // tab/panel iteration if we add it with js here
        // It sits inside the [role="tablist"], so it takes the same contract as
        // the widget-rendered tabs: an href so Enter activates it natively, a tab
        // role so it is announced as one, and a starting tabindex of -1 for the
        // roving tab stop. Without these it was not reachable at all by keyboard
        // in the mobile layout (ACS-1348).
        $('.tabs').prepend('<a class="tab tab-FullTextCss" id="' + FULL_TEXT_TAB_ID + '" href="javascript:;" role="tab" aria-selected="false" tabindex="-1"><i class="tab__icon icon-full-text icon-splitview_read"><span class="tab__icon-text">Full Text</span></i><div class="tab__text">Full Text</div></a>');

        // loop through ref-list (references) and paint in data-id
        var refIds = $('.ref-list [data-content-id]');
        refIds.each(function () {
            var newId = $(this).data('contentId');
            $(this).attr('data-id', newId);
        });

        // REFACTOR NOTE:
        // moving footers should be done on the backend and could
        // be resolved by using a unique splitview template

        // move the footers into the article pane
        $('body.pg_articlesplitview .widget-instance-SitePageFooter, body.pg_articlesplitview .site-theme-footer').appendTo('.article');

        // loop through tabs
        $tabLinks.each(function (i) {
            // tabs get data-tab index to match to tabPanel, and the tab/panel
            // pair gets its ARIA wiring: unique ids, tab -> panel through
            // aria-controls and panel -> tab through aria-labelledby, so
            // assistive technology can report which panel a tab controls and
            // which tab names the visible panel (ACS-1348).
            var tabId = TAB_ID_PREFIX + i;
            var panelId = PANEL_ID_PREFIX + i;

            $(this).attr({
                'data-tab': i,
                'id': tabId,
                'aria-controls': panelId,
                'tabindex': '-1'
            });

            $tabPanels.eq(i).attr({
                'id': panelId,
                'aria-labelledby': tabId
            });
        });

        // after the Full Text tab is in place, so it is named too
        labelTabsForAssistiveTechnology();

        // loop through panels
        var panelDict = {};
        $tabPanels.each(function (i) {
            var link = $(this).find('div[content-id]');
            link.each(function () {
                panelDict[$(this).attr('content-id')] = i;
            });
        });
    }

    // initialize JS document ready
    function init() {
        // REFACTOR NOTE:
        // body class list needs to be reconsidered- need to inherit
        // .pg_article, but accessing body class list
        // is overly complicated through existing widget config and external masterpage
        // could be solved through dedicated view template

        // add .pg_article to inherit article styling-
        $('body.pg_ArticleSplitView, body.pg_articlesplitview, body.pg_Chapter, body.pg_chapter').removeClass('pg_ArticleSplitView').addClass('pg_article pg_articlesplitview');

        rightPanelHeight();

        // set isMobile for checks
        var isMobile = getDocWidth() < 1024 ? true : false;


        // VARIABLES FROM WIDGET OUTPUT
        // all tabs coming from widget
        var $tabLinks = $('body.pg_articlesplitview .tab');
        // all tab panels coming from widgets
        var $tabPanels = $('body.pg_articlesplitview .panels > .dynamic-widget-inner-wrap');
        // wrapper for all widget panels
        var $tabPanelWrap = $('body.pg_articlesplitview .panels');
        // article content wrapper
        var $contentPanel = $('body.pg_articlesplitview .article');

        // ***GENERATE THINGS WE NEED
        generateHtml($tabLinks, $tabPanels);

        // Firefox treats elements with overflow: scroll as focusable so they can
        // be scrolled with the keyboard, which surfaces the article (left) and
        // panels (right) scroll containers as spurious tab stops with no
        // associated control. Other browsers do not. Suppress these stops with
        // tabindex="-1"; users can still tab to interactive elements inside,
        // and programmatic focus (skip-nav, modals) still works.
        $contentPanel.attr('tabindex', '-1');
        $tabPanels.attr('tabindex', '-1');

        // cache full-text__tab
        var $fullTextTab = $('.tab-FullTextCss');

        $('.figure-table-wrapper .table-wrap-title').each(function () {
            $(this).attr('data-id', this.id);
        });

        // TAB ClICKS- *not full text tab*
        $tabLinks.on('click', function () {
            // make sure content panel is hidden
            if (isMobile) {
                $contentPanel.hide();
            }
            // make sure tab content wrapper is visible
            $tabPanelWrap.show();
            // remove all active tab states
            $tabLinks.add($fullTextTab).removeClass('active').attr('aria-selected', 'false');
            // make clicked tab active
            $(this).addClass('active').attr('aria-selected', 'true');
            // move the strip's single tab stop onto the newly selected tab
            setRovingTabStop($(this));
            // hide all panels first
            $tabPanels.hide().attr('aria-hidden', 'true');
            // get the clicked link's tab id
            var activePanel = $(this).attr('data-tab');

            // show the panel with matching tab id
            $tabPanels.eq(activePanel).show().attr('aria-hidden', 'false');
            return false;
        });

        // SPLIT-VIEW TAB KEYBOARD CONTRACT
        // The strip declares role="tablist"/role="tab", so it owes the ARIA Tabs
        // keyboard pattern: Left/Right and Home/End move focus, Enter or Space
        // activates. Manual activation is used deliberately - auto-activating on
        // every arrow press would swap the right pane repeatedly, which is noisy
        // for screen reader users working through a long article. Delegated from
        // the document so the injected Full Text tab, and whatever survives
        // removeTabsWithNoContent, are all covered without rebinding (ACS-1348).
        $(document).on('keydown', 'body.pg_articlesplitview .tabs .tab', function (e) {
            var $tabs = getVisibleTabs();
            var currentIndex = $tabs.index(this);
            var targetIndex;

            if (currentIndex === -1) {
                return;
            }

            switch (e.key) {
                case 'ArrowRight':
                    targetIndex = (currentIndex + 1) % $tabs.length;
                    break;
                case 'ArrowLeft':
                    targetIndex = (currentIndex - 1 + $tabs.length) % $tabs.length;
                    break;
                case 'Home':
                    targetIndex = 0;
                    break;
                case 'End':
                    targetIndex = $tabs.length - 1;
                    break;
                case ' ':
                    // Enter already activates natively - every tab is an anchor
                    // with an href. Space has to be taken over so it activates
                    // the tab instead of scrolling the page.
                    e.preventDefault();
                    $(this).trigger('click');
                    return;
                default:
                    return;
            }

            e.preventDefault();

            var $targetTab = $tabs.eq(targetIndex);
            // Under manual activation the tab stop follows focus, so tabbing back
            // into the strip returns to where the user left off.
            setRovingTabStop($targetTab);
            $targetTab.focus();
        });

        if ($('.pg_articlesplitview').length) {

            // Handle Reference Clicks

            $(document).on('click', 'body.pg_articlesplitview a.xref-bibr[data-modal-source-id], body.pg_Chapter a.xref-bibr[reveal-id]', function () {
                var refId = $(this).data('modalSourceId').toLowerCase();

                jumpToReferenceInRightPane(refId);
            });

            // This works for figures, but not References - which can't get the .attr('data-display-order')
            $('body.pg_articlesplitview a[reveal-id]:not(.xref-corresp):not(.split-view-modal)').on('click',
                function () {
                    var panelTriggerId = $(this).attr('reveal-id').split(' ')[0];
                    return jumpToTarget(panelTriggerId);
                });

            // all links in article that link to footnotes in the article text
            $('body.pg_articlesplitview .xref-fn a:not(split-view-modal)').on('click', function () {

                var $targetTab = $('.tab-ReferencesCss, .tab-split-view-references-pane');
                if ($targetTab.length && !$targetTab.hasClass('active')) {
                    // If the tab is NOT active, have to switch over to it
                    $targetTab.click();
                }
            });

            $('#revealModal.reveal-modal').addClass('fn-modal');

            $('.article').scroll(function () {
                var articleScrollTop = $('.article').scrollTop();
                var $bookChapterBody = $('.article .book-chapter-body');

                $('h3').each(function () {
                    var subheadingArticleId = $bookChapterBody.length ? $(this).data('magellan-destination') : $(this).attr('id');
                    var scrollToLink = $(`.section-jump-link a[href="#${subheadingArticleId}"]`);
                    $(scrollToLink).closest('.section-jump-link').addClass('level-2');
                });

                $('.jumplink-heading').each(function () {
                    var topDistance = $(this).offset().top;
                    var headerHeight = $('.master-header').height();
                    var subheadingArticleId;
                    var scrollToLink;
                    if($bookChapterBody.length) {
                        subheadingArticleId = $(this).data('magellan-destination');
                        scrollToLink = $(`.section-jump-link a[href="#${subheadingArticleId}"]`);

                        if (topDistance - 200 < headerHeight && topDistance - 200 < articleScrollTop) {
                            if ($(scrollToLink).length) {
                                $('.section-jump-link.active').removeClass('active');
                                $(scrollToLink).closest('.section-jump-link').addClass('active');
                            }
                        }
                    } else {
                        subheadingArticleId = $(this).attr('id');
                        scrollToLink = $(`.section-jump-link__link-wrap a[href="#${subheadingArticleId}"]`);
                        if (topDistance - 200 < headerHeight && topDistance - 200 < articleScrollTop) {
                            if ($(scrollToLink).length) {
                                $('.jumplink-list li').removeClass('active');
                                $(scrollToLink).closest('.section-jump-link').addClass('active');
                            }
                        }
                    }

                });
            });

            $('.widget-SplitView').on('click', 'a.scrollTo[href*="#"]:not([href="#"])', function () {
                if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                    let $html = $('html');
                    let $article = $('.article');
                    let $jumplinkDestination = $(this.hash);
                    let pixelOffset = 60;
                    let stickyNavEnabled = $('body').hasClass('js-sticky-splitview-nav');
                    // Scope the focus-move to the article Contents jumplinks only,
                    // matching the non-split-view behavior in client.jumpLinks.js.
                    let isJumpLink = $(this).hasClass('jumplink');

                    $jumplinkDestination = $jumplinkDestination.length ? $jumplinkDestination : $(`[name="${this.hash.slice(1)}"]`);

                    function _smoothScrollHtmlAnimation() {
                        $html.delay(100).animate({
                            scrollTop: $('.splitview__wrapper').offset().top
                        }, 250);
                    }

                    function _smoothScrollArticleAnimation() {
                        $article.delay(100).animate({
                            scrollTop: $article.scrollTop() + $jumplinkDestination.position().top - pixelOffset
                        }, 250, function () {
                            // Move keyboard focus into the destination section so the
                            // next Tab continues from there, not from the jumplink
                            // (WCAG 2.4.3). Reuses the shared helper so split-view and
                            // default behavior stay identical.
                            if (isJumpLink && SCM.JumpLinks && typeof SCM.JumpLinks.moveFocusAfterTarget === 'function') {
                                SCM.JumpLinks.moveFocusAfterTarget($jumplinkDestination);
                            }
                        });
                    }

                    if ($jumplinkDestination.length) {

                        if (isMobile) {
                            $('.tab-FullTextCss').click();
                            if (stickyNavEnabled) {
                                _smoothScrollHtmlAnimation();
                                _smoothScrollArticleAnimation();
                            } else {
                                _smoothScrollArticleAnimation();
                            }
                        } else {
                            if (stickyNavEnabled) {
                                _smoothScrollHtmlAnimation();
                                _smoothScrollArticleAnimation();
                            } else {
                                _smoothScrollArticleAnimation();
                            }
                        }

                        return false;
                    }
                }
            });
        }


        // FULL TEXT TAB CLICK
        // specific behavior for mobile-only
        // full text tab
        $fullTextTab.on('click', function () {
            // remove active tab states
            $tabLinks.removeClass('active').attr('aria-selected', 'false');
            // make full text tab active
            $(this).addClass('active').attr('aria-selected', 'true');
            // move the strip's single tab stop onto the newly selected tab
            setRovingTabStop($(this));
            // hide all the panels
            $tabPanelWrap.hide();
            // show the full text container
            $contentPanel.show();
        });



        // RESIZE TO DESKTOP
        // trigger click on first tab ONLY when resizing
        // from small to large
        $(window).on('resize', function () {

            isMobile = getDocWidth() < 1024 ? true : false;

            // the article pane is only a tab panel while the mobile layout swaps
            // it in and out behind the Full Text tab
            syncFullTextTabPanel($contentPanel, isMobile);

            if (isMobile === false) {
                $contentPanel.show();
                if ($('.tab.active').not('.tab-FullTextCss').length === 0) {
                    $('.tab:visible').first().trigger('click');
                }
            } else {
                if ($('.tab.active').not('.tab-FullTextCss').length > 0) {
                    $('.tab.active').trigger('click');
                }
            }
        });

        // Document Ready
        $(function () {
            removeTabsWithNoContent();

            // ONLOAD ACTIVATE FIRST TAB
            // activate fulltext tab on mobile or
            // next tab on desktop
            if (isMobile === true) {
                $tabPanelWrap.hide();
                // set the selected state and the tab stop by hand rather than
                // triggering a click, which would also force an inline display
                // value onto the article pane
                $fullTextTab.addClass('active').attr('aria-selected', 'true');
                setRovingTabStop($fullTextTab);
            } else {
                $('.tab:visible').first().trigger('click');
            }

            syncFullTextTabPanel($contentPanel, isMobile);

            $('.linked-name').on('click', function () {
                if ($(this).parent('.al-author-name').position().left + 300 > $('.article').width()) {
                    $(this).next('.al-author-info-wrap').addClass('al-author-info-wrap--right');
                }
            });

            // This is what happens when inconsistent naming conventions are applied to the body
            $('.pg_Chapter').find('.tabs, .panels').css('display', 'inline-flex');
            $('.pg_Chapter .tab[data-tab="1"]').addClass('active');
            $('.pg_Chapter .panels .dynamic-widget-inner-wrap[data-display-order="1"]').show();

            jumpToSubSection();
        });
    }
})(jQuery);